var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M.387 26.335c0-3.961 1.354-8.165 4.062-12.612 2.746-4.484 7.68-8.576 14.803-12.276l1.335 2.523c-3.561 2.54-6.195 4.67-7.902 6.39-3.005 3.101-4.507 6.072-4.507 8.912 0 .972.278 1.607.834 1.906.557.337 1.04.505 1.447.505 1.41-.187 2.338-.28 2.783-.28 2.374 0 4.322.878 5.843 2.634 1.521 1.719 2.282 3.812 2.282 6.278 0 2.765-.835 5.082-2.505 6.95-1.67 1.832-3.97 2.747-6.9 2.747-3.45 0-6.251-1.233-8.403-3.7C1.444 33.81.387 30.484.387 26.336zm25.02-1.435c0-4.185 1.447-8.501 4.34-12.948 2.894-4.447 7.736-8.427 14.525-11.94l1.336 2.523c-3.34 2.354-5.9 4.428-7.68 6.222-3.153 3.176-4.73 6.128-4.73 8.856 0 .785.204 1.42.612 1.906.408.486.965.729 1.67.729 1.41-.187 2.337-.28 2.782-.28 2.337 0 4.266.859 5.787 2.578 1.559 1.719 2.338 3.83 2.338 6.334 0 2.915-.854 5.269-2.56 7.063-1.707 1.756-4.026 2.634-6.956 2.634-3.34 0-6.085-1.233-8.237-3.7-2.151-2.503-3.227-5.829-3.227-9.977z",
    fill: "#0085FF"
  })));
}

export default SvgQuote;